import React, { useEffect, useState } from 'react';
import { Link, Redirect } from "@reach/router";
import AppState from "js/stores/AppState";
import { makeRequest } from 'js/services/Network';
import AppUser from 'js/stores/AppUser';
import WelcomeHeadline from './WelcomeHeadline';
import StoreProducts from 'js/components-v2/pages/MSellerPage/StoreProducts';
import VideoFootage from 'js/components-v2/pages/MSellerPage/VideoFootage';
import Tour from 'reactour';
import userCountry from 'js/services/UserCountry';
import HeroSection from "js/components-v2/pages/MSellerPage/HeroSection";
import AppContent from "js/components/AppContent";
import { Card, CardImage, CardLink, CardText, CardTitle } from 'js/components-v2/pages/HomePage/Card';
import analytics from 'js/services/Analytics';
import UserCountry from 'js/services/UserCountry';
import LoginSignupDialogState from 'js/stores/LoginSignupDialogState';
import { Footer } from 'js/new/Components/PageSections';

const MSellerPage = (props) => {
  const [items, setItems] = useState([]);
  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(async () => {
    AppState.setCurrentPage('MSellerPage');

    analytics.track('SP_mseller_LP', {
      'Seller': props.mseller,
      'Country': UserCountry(),
    });

    window.scrollTo(0, 0);
    AppState.setMSeller(props.mseller);

    if (props.action && props.action === 'verify') {
      AppState.setShowConfirmationCode(true);
    }

    if (undefined === props.action || props.action !== 'verify') {
      const response = await makeRequest('mseller-items', {
        mseller: props.mseller,
      });

      // If the response is correct assign the response.data to items
      if (response.data) {
        setItems(response.data.data);
      }
    }

    return () => {
      AppState.setMSellerLogin(false);
    }
  }, []);

  useEffect(() => {
    setIsTourOpen(true);
  }, []);

  const activateCheckout = (cta) => {
    analytics.track(cta, {
      'Seller': props.mseller,
      'Country': UserCountry(),
    });

    AppState.setMSellerLogin(props.mseller);
    AppState.setDialogProps({
      loginTitle: userCountry() === 'NG' ? 'Activate your Checkout' : 'Activate your Store',
      loginButtonLabel: userCountry() === 'NG' ? 'Get my Checkout!' : 'Get my Store!',
      signupButtonLabel: userCountry() === 'NG' ? 'Get my Checkout!' : 'Get my Store!',
      showForgotPassword: false,
    });
    AppState.showLoginSignup('signup');
  }

  return (
    <>
      <div className='mseller-page'>
        {(AppUser.isLoggedIn && false !== AppState.msellerLogin) && <Redirect to={'/store-activated'} noThrow />}
        {(AppUser.isLoggedIn && false === AppState.msellerLogin) && <Redirect to={'/'} noThrow />}
        <div className='pod-container mseller-content'>
          <WelcomeHeadline mseller={props.mseller} activationHandler={(e) => { e.preventDefault(); activateCheckout('CTA_SP_mseller_LP_activate_store1') }} />

          <StoreProducts items={items} />

          <div>
            <div className='pod-hero-container pod-container align-items-stretch'>
              <HeroSection mseller={props.mseller} activationHandler={(e) => { e.preventDefault(); activateCheckout('CTA_SP_mseller_LP_activate_store2') }} />
            </div>
          </div>

        </div>

        <div className='pod-cards-container top-cards padding-top-0'>
          <div className='pod-container d-md-flex align-items-md-stretch flex-md-wrap'>
          </div>
          <div className='pod-container blue-card'>
            <Card dark={true}>
              <div className='d-md-flex align-items-md-center justify-content-md-between'>
                <div>
                  <CardTitle>Your one stop checkout for selling anywhere</CardTitle>
                  <CardText>
                    When you’re selling
                    on <strong>Facebook</strong>, <strong>Instagram</strong>, <strong>WhatsApp</strong> and other
                    selling apps,
                    PayOnDelivery handles <strong>payment</strong> and <strong>shipping</strong> so you don’t have to
                    go
                    through the hassle.
                  </CardText>
                </div>
                <div>
                  <CardImage src='/images/v2/logos-selling-card.svg' alt='Activate your checkout' />
                  <Link to={'/login/'} className='btn btn-card' onClick={(e) => { e.preventDefault(); activateCheckout('CTA_SP_mseller_LP_activate_store3') }}>
                    {userCountry() === 'NG' && 'Activate your Checkout'}
                    {userCountry() !== 'NG' && 'Activate your Store'}</Link>
                </div>
              </div>
            </Card>
          </div>
        </div>

        <Footer />
      </div>

      <Tour
        className='mseller-tour'
        maskClassName='mseller-tour-mask'
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        getCurrentStep={(currentStep) => {
          // Add a class to the element
          const tour = document.querySelector('.mseller-tour');
          const element = document.querySelector('body');

          if (!tour) {
            return;
          }

          element.className = '';
          element.classList.add('tour-step-' + currentStep);

          if (currentStep < 3) {
            element.classList.add('tour-bottom');
            return;
          }

          if (currentStep === 4) {
            element.classList.add('tour-finished');
            return;
          }

          element.classList.add('tour-left');
        }
        }
        nextButton={<button className='btn btn-next-tour'>Next</button>}
        lastStepNextButton={<Link to={'//help.payondelivery.com/en/collections/85035-frequently-asked-questions'}
          className='btn btn-next-tour'>FAQ</Link>}
        steps={[
          {
            selector: '.pod-mobile-nav',
            content: () => (
              <div>
                <h4>Hi, {props.mseller}!</h4>
                <p>Welcome to your PayOnDelivery checkout that helps you sell
                  faster and more on Instagram and other sites!</p>
              </div>
            ),
            position: 'bottom',
          },
          {
            selector: '.pod-mobile-nav',
            content: 'PayOnDelivery is your trusted store checkout for selling anywhere and everywhere. Your buyers trust you more. We pickup, deliver and get you paid faster saving you time.',
            position: 'bottom',
          },
          {
            selector: '.store-title',
            content: 'We took the liberty to help you set up your checkout with some products you’re selling. You can add more products to this easily.',
            position: 'bottom',
          },
          {
            selector: '.btn-activate-store',
            content: 'Activate your store now to sync your store to you instagram bio before it is claimed by another seller!',
            position: 'left',
          },
          {
            content: 'Need more information or help loading more items? Visit our FAQ.',
            style: {
              top: '-200px',
            },
          }
        ]}
      />
    </>
  );
};

export default MSellerPage;
